/**
 * 埋点事件与操作码统一维护文件
 * 仅在这里集中管理，业务侧只引用常量，避免魔法字符串散落各处
 */

/** 投注记录 Tab 埋点事件名 */
export const TRACK_EVENT_RECORD_TAB_SPM = "s_record_tab_spm";

/** 投注记录页曝光埋点事件名 */
export const TRACK_EVENT_RECORD_PAGE_SPM = "s_record_spm";

/** 投注记录帮助弹窗点击埋点事件名 */
export const TRACK_EVENT_RECORD_HELP_SPM = "c_record_help_spm";

/** 投注记录页入口按钮点击埋点事件名 */
export const TRACK_EVENT_RECORD_ENTRY_SPM = "c_record_spm";

/** SDK 启动页展示埋点事件名 */
export const TRACK_EVENT_SDK_START_PAGE_SPM = "s_start_spm";

/** SDK 启动页加载时长埋点事件名（附加参数：加载总时长 ms） */
export const TRACK_EVENT_SDK_START_TIME_SPM = "s_start_time_spm";

/** SDK 启动初始化接口请求埋点事件名 */
export const TRACK_EVENT_SDK_START_INTERFACE_SPM = "s_start_interface_spm";

/** SDK 启动初始化接口请求时长埋点事件名 */
export const TRACK_EVENT_SDK_START_INTERFACE_TIME_SPM = "s_start_interface_time_spm";

/** 投注页维护字段提示浮层埋点事件名 */
export const TRACK_EVENT_BET_MAINTENANCE_SPM = "s_bet_maintenance_spm";

/** 投注页货币切换埋点事件名 */
export const TRACK_EVENT_CHANGE_TYPE_SPM = "c_change_type_spm";

/** 投注页调起充值页埋点事件名 */
export const TRACK_EVENT_TO_RECHARGE_SPM = "s_cp_charge_spm";

/** 维护弹窗埋点事件名 */
export const TRACK_EVENT_MAINTENANCE_SPM = "s_maintenance_spm";

/**
 * 维护弹窗上传触发来源
 * - room_maintenance: 投注维护弹窗/状态展示
 * - server_maintenance: 服务器维护弹窗展示
 */
export const MAINTENANCE_TRIGGER = {
  ROOM_MAINTENANCE: "room_maintenance",
  SERVER_MAINTENANCE: "server_maintenance",
} as const;

export type MaintenanceTriggerCode =
  (typeof MAINTENANCE_TRIGGER)[keyof typeof MAINTENANCE_TRIGGER];

/**
 * 投注记录 Tab SPM 操作码
 *
 * 说明：
 * - us_ 前缀：未结算（unsettled）
 * - s_  前缀：已结算（settled）
 */
export const RECORD_TAB_SPM = {
  /** 未结算-全部 */
  UNSETTLED_ALL: "us_all",
  /** 未结算-待结算 */
  UNSETTLED_AWAITING: "us_awaiting",
  /** 未结算-审核中 */
  UNSETTLED_PENDING: "us_pending",

  /** 已结算-全部 */
  SETTLED_ALL: "s_all",
  /** 已结算-赢 */
  SETTLED_WIN: "s_win",
  /** 已结算-输 */
  SETTLED_LOSE: "s_lose",
  /** 已结算-其他 */
  SETTLED_OTHER: "s_other",
} as const;

export type RecordTabSpmCode =
  (typeof RECORD_TAB_SPM)[keyof typeof RECORD_TAB_SPM];
